import { EnergyProductionConsumptionSummary } from './EnergyProductionConsumptionSummary'
import { Model } from './Model'
import { MonitoringDataDataType } from '@/types'

export class MonitoringData extends Model {
    raw: MonitoringDataDataType

    energy_updated_at?: Date

    errors: {
        message: string | string[]
    }

    system: {
        production?: EnergyProductionConsumptionSummary
        consumption?: EnergyProductionConsumptionSummary
        summary: {
            current_power_production_w: number
            pto_date?: Date
        }
    }

    constructor(data: MonitoringDataDataType) {
        super(data)
        this.raw = data
        this.errors = data.errors
        this.system = {
            production: data.system.production
                ? new EnergyProductionConsumptionSummary(data.system.production) : undefined,
            consumption: data.system.consumption
                ? new EnergyProductionConsumptionSummary(data.system.consumption) : undefined,
            summary: {
                current_power_production_w: Model.toNumber(data.system.summary.current_power_production_w, 0) as number,
                pto_date: Model.toDate(data.system.summary.pto_date)
            }
        }
        this.energy_updated_at = Model.toDate(data.energy_updated_at)
    }
}
